import { confluenceLocalStorageInstance } from '@confluence/storage-manager/entry-points/storageInstance';

import { TWENTY_EIGHT_DAYS_IN_SECONDS } from './time-constants';

export const markDiscoveryExperienceAsSeen = (experienceKey: string) => {
	confluenceLocalStorageInstance.setItem(experienceKey, true, TWENTY_EIGHT_DAYS_IN_SECONDS);
};
